import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=64d5aaee&scoped=true&"
import script from "./ActivityCard.vue?vue&type=script&lang=js&"
export * from "./ActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCard.vue?vue&type=style&index=0&id=64d5aaee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d5aaee",
  null
  
)

export default component.exports